import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import DOMPurify from 'dompurify';

/**
 * Replaces subject within a string with the given component.
 */
function Replace(props) {
  const { content, toReplace, replaceWith } = props;

  // santitize and strip whitespace from the provided html.
  const nodes = parse(
    DOMPurify.sanitize(content, { ADD_ATTR: ['target'] }).replace(/\n|\r/g, ''),
    {
      replace: (domNode) => {
        if (domNode.data && domNode.data.includes(toReplace)) {
          let split = domNode.data.split(toReplace);
          const element = split.map((e, i) => {
            if (i < split.length - 1) {
              return (
                <React.Fragment key={i}>
                  {e}
                  {replaceWith}
                </React.Fragment>
              );
            }
            return <React.Fragment key={i}>{e}</React.Fragment>;
          });
          return <React.Fragment>{element}</React.Fragment>;
        }
      },
    }
  );
  return nodes;
}

Replace.propTypes = {
  content: PropTypes.string.isRequired,
  toReplace: PropTypes.string.isRequired,
  replaceWith: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    .isRequired,
};

Replace.defaultProps = {};

export default Replace;
